const proTypes = {
    onboarding: 'onboarding',
    shop: 'shop',
    ISLAND_EXTRA_OFFER: 'island_extra_offer',
    ADVERTISEMENT: 'advertisement',
    expressionTags: 'expression_category',
    profileAvatar: 'profile_avatar',
    testAvatar: 'test_avatar',
    miniGrammar: 'mini_grammar',
    catalog: 'weekly_english',
    favourite: 'favorite_expression',
    expression_learner: 'expression_learner',
    CONTENT: 'content',
    grammar: 'grammar',
    speakbotVocabulary: 'chatbot_expression_learner',
    speakbot: 'chatbot',
    checkpoint: 'checkpoint',
    BLOCKED_EXPRESSION_LEARNER: 'blocked_expression_learner',
    BLOCKED_CONTENT_LESSON: 'blocked_content',
    BLOCKED_GRAMMAR: 'blocked_grammar',
    BLOCKED_SPEAK_BOT_EXP_LEARNER: 'blocked_chatbot_expression_learner',
    BLOCKED_SPEAK_BOT_TALK: 'blocked_chatbot',
    UNLOCK_ISLAND: 'unlock_island',
    SPECIAL_OFFER: 'special_offer',
    classroomProContentClicked: 'classroomProContentClicked',
};
export default proTypes;
